
<div id="userProfile" class="page-layout carded  fullwidth" fxLayout="column">
    <ngx-loading [show]="loading"></ngx-loading>


    <div class="content p-24">
        <div class="mat-elevation-z8">
            <div style="max-width: 100%!important;">
                <mat-card fxFlex="100" class="mt-10">

                    <mat-card-content>
                        <app-jobs-by-type-chart fxFlex="25"></app-jobs-by-type-chart>
                        <app-users-type-chart fxFlex="25"></app-users-type-chart>
                        <app-jobs-evolutions-month-chart fxFlex="25"></app-jobs-evolutions-month-chart>
                        <app-jobs-by-city-chart fxFlex="25"></app-jobs-by-city-chart>
                    </mat-card-content>

                    <mat-card-actions style="text-align: right; padding: 10px">

                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>

</div>
